/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAccountSettingsItemAllOf,
    GetAccountSettingsItemAllOfFromJSON,
    GetAccountSettingsItemAllOfFromJSONTyped,
    GetAccountSettingsItemAllOfToJSON,
} from './GetAccountSettingsItemAllOf';
import {
    PostAccountSettingsItem,
    PostAccountSettingsItemFromJSON,
    PostAccountSettingsItemFromJSONTyped,
    PostAccountSettingsItemToJSON,
} from './PostAccountSettingsItem';
import {
    PostAccountSettingsItemAddress,
    PostAccountSettingsItemAddressFromJSON,
    PostAccountSettingsItemAddressFromJSONTyped,
    PostAccountSettingsItemAddressToJSON,
} from './PostAccountSettingsItemAddress';
import {
    PostAccountSettingsItemMediaInformation,
    PostAccountSettingsItemMediaInformationFromJSON,
    PostAccountSettingsItemMediaInformationFromJSONTyped,
    PostAccountSettingsItemMediaInformationToJSON,
} from './PostAccountSettingsItemMediaInformation';

/**
 * 
 * @export
 * @interface GetAccountSettingsItem
 */
export interface GetAccountSettingsItem {
    /**
     * 名前（性）
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    firstName: string;
    /**
     * 名前（名）
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    lastName: string;
    /**
     * 企業名
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    companyName: string;
    /**
     * 
     * @type {PostAccountSettingsItemAddress}
     * @memberof GetAccountSettingsItem
     */
    address?: PostAccountSettingsItemAddress;
    /**
     * 電話番号
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    phoneNumber: string;
    /**
     * FAX番号
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    faxNumber?: string;
    /**
     * 媒体情報リスト
     * @type {Array<PostAccountSettingsItemMediaInformation>}
     * @memberof GetAccountSettingsItem
     */
    mediaInformation: Array<PostAccountSettingsItemMediaInformation>;
    /**
     * ヘッドラインメール受信するか
     * @type {boolean}
     * @memberof GetAccountSettingsItem
     */
    isReceiveHeadlineEmail: boolean;
    /**
     * 個別プレスリリースメール受信するか
     * @type {boolean}
     * @memberof GetAccountSettingsItem
     */
    isReceivePressReleaseEmail: boolean;
    /**
     * HTMLメール受信するか
     * @type {boolean}
     * @memberof GetAccountSettingsItem
     */
    isReceiveHtmlEmail: boolean;
    /**
     * 最適化メール受信するか
     * @type {boolean}
     * @memberof GetAccountSettingsItem
     */
    isReceiveOptimizedEmail: boolean;
    /**
     * エイプリルフール・エイプリルドリームメール受信するか
     * @type {boolean}
     * @memberof GetAccountSettingsItem
     */
    isAprilFoolAndAprilDreamEmail: boolean;
    /**
     * ユーザーID (メールアドレス形式)
     * @type {string}
     * @memberof GetAccountSettingsItem
     */
    userId: string;
}

export function GetAccountSettingsItemFromJSON(json: any): GetAccountSettingsItem {
    return GetAccountSettingsItemFromJSONTyped(json, false);
}

export function GetAccountSettingsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccountSettingsItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'companyName': json['company_name'],
        'address': !exists(json, 'address') ? undefined : PostAccountSettingsItemAddressFromJSON(json['address']),
        'phoneNumber': json['phone_number'],
        'faxNumber': !exists(json, 'fax_number') ? undefined : json['fax_number'],
        'mediaInformation': ((json['media_information'] as Array<any>).map(PostAccountSettingsItemMediaInformationFromJSON)),
        'isReceiveHeadlineEmail': json['is_receive_headline_email'],
        'isReceivePressReleaseEmail': json['is_receive_press_release_email'],
        'isReceiveHtmlEmail': json['is_receive_html_email'],
        'isReceiveOptimizedEmail': json['is_receive_optimized_email'],
        'isAprilFoolAndAprilDreamEmail': json['is_april_fool_and_april_dream_email'],
        'userId': json['user_id'],
    };
}

export function GetAccountSettingsItemToJSON(value?: GetAccountSettingsItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'first_name': value.firstName,
        'last_name': value.lastName,
        'company_name': value.companyName,
        'address': PostAccountSettingsItemAddressToJSON(value.address),
        'phone_number': value.phoneNumber,
        'fax_number': value.faxNumber,
        'media_information': ((value.mediaInformation as Array<any>).map(PostAccountSettingsItemMediaInformationToJSON)),
        'is_receive_headline_email': value.isReceiveHeadlineEmail,
        'is_receive_press_release_email': value.isReceivePressReleaseEmail,
        'is_receive_html_email': value.isReceiveHtmlEmail,
        'is_receive_optimized_email': value.isReceiveOptimizedEmail,
        'is_april_fool_and_april_dream_email': value.isAprilFoolAndAprilDreamEmail,
        'user_id': value.userId,
    };
}

